import { createReducer, isAnyOf } from '@reduxjs/toolkit';
import {
  readMessages,
  readMessagesFailure,
  readMessagesSuccess,
} from 'modules/chat/actions';

/**
 * @typedef {boolean} IsReadingMessagesState
 */

/** @type {IsReadingMessagesState} */
const initialState = false;

const load = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addMatcher(readMessages.match, load)
    .addMatcher(isAnyOf(readMessagesSuccess.match, readMessagesFailure.match), reset);
});
